{{ this.visibleValue | number }}
